/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ValoreStoricoDTO } from './valore-storico-dto';


export interface StoricoEntryDTO { 
    identificatore?: string;
    etichetta?: string;
    eav_target?: StoricoEntryDTOEavTargetEnum;
    componente_id?: string;
    valore?: ValoreStoricoDTO;
    modalita?: StoricoEntryDTOModalitaEnum;
    valid_from?: string;
    is_tombstone?: boolean;
}
export enum StoricoEntryDTOEavTargetEnum {
    ANAGRAFICA_RICHIEDENTE = 'ANAGRAFICA_RICHIEDENTE',
    NUCLEO_FAMILIARE_COMPONENTE = 'NUCLEO_FAMILIARE_COMPONENTE',
    PRATICA_ROOT = 'PRATICA_ROOT'
};
export enum StoricoEntryDTOModalitaEnum {
    PRESA_IN_CARICO = 'PRESA_IN_CARICO',
    AGGIORNA = 'AGGIORNA',
    SOVRASCRIVI_ORIGINALE = 'SOVRASCRIVI_ORIGINALE'
};



